import { render } from "./ContributePage.vue?vue&type=template&id=261e607e&scoped=true"
import script from "./ContributePage.vue?vue&type=script&lang=js"
export * from "./ContributePage.vue?vue&type=script&lang=js"

import "./ContributePage.vue?vue&type=style&index=0&id=261e607e&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261e607e"]])

export default __exports__